import appConfig from "@/config/app-config";

export function ping() {
  return fetch(`${appConfig.apiBase}/healthping`);
}

export const challenge = async (): Promise<Response> => {
  const challengeRequest = {
    method: "bankid",
  };

  return fetch(`${appConfig.apiBase}/auth/challenge`, {
    method: "POST",
    body: JSON.stringify(challengeRequest),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const completeLogin = async (
  challengeToken: string
): Promise<Response> => {
  const loginRequest = {
    challengeToken,
    method: "bankid",
  };

  return fetch(`${appConfig.apiBase}/auth/login`, {
    method: "POST",
    body: JSON.stringify(loginRequest),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Token ${challengeToken}`,
    },
  });
};

export const loginWithCredentials = async (
  personalNumber?: string
): Promise<Response> => {
  const credentials = {
    identifier: personalNumber?.replace("-", ""),
    method: "test",
  };

  return fetch(`${appConfig.apiBase}/auth/login`, {
    method: "POST",
    body: JSON.stringify(credentials),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const beginLoginFlow = async (): Promise<SecureStartResponse> => {
  return new Promise((resolve, reject) => {
    fetch(`${appConfig.apiBase}/auth/login/qr`, {
      method: "POST",
    })
      .then(
        (res) => {
          if (res.ok) {
            return res.json();
          }

          reject(new Error("Something went wrong"));
        },
        (err: Error) => reject(err)
      )
      .then(
        (json) => {
          resolve(json as SecureStartResponse);
        },
        (err: Error) => reject(err)
      );
  });
};

export const refreshQrCode = async (
  sessionId: string,
  signal?: AbortSignal
): Promise<BankIdPollingResponse> => {
  return new Promise((resolve, reject) => {
    fetch(`${appConfig.apiBase}/auth/login/qr/${sessionId}`, {
      signal,
    })
      .then(
        (res) => {
          if (res.ok) {
            return res.json();
          }

          reject(new Error("Something went wrong"));
        },
        (err: Error) => reject(err)
      )
      .then(
        (json) => {
          resolve(json as BankIdPollingResponse);
        },
        (err: Error) => reject(err)
      );
  });
};
